let installed = false;

export function installResizeObserverWorkaround() {
  if (installed) return;
  installed = true;

  if (typeof window === 'undefined' || typeof window.ResizeObserver === 'undefined') {
    return;
  }

  const NativeResizeObserver = window.ResizeObserver;

  // Defer ResizeObserver callbacks to the next frame to avoid
  // same-tick measure/mutate feedback loops in complex graph UIs.
  window.ResizeObserver = class ResizeObserverWithRaf extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}

